import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: ${Styles.color.white};
`;

/**
 * Brand circular spinner matching the partner-linking loading design — a
 * light track with a TH-red arc rotating continuously. Decorative; the
 * accessible status text lives on the parent (role="status" + aria-label).
 */
const Spinner = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: 4px solid rgba(0, 0, 0, 0.12);
  border-top-color: ${Styles.color.primary};
  animation: partner-linking-spin 0.8s linear infinite;

  ${Styles.desktop`
    width: 3.5rem;
    height: 3.5rem;
  `}

  @keyframes partner-linking-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

/**
 * Full-page loading view shared by the partnership-linking pages
 * (`initiate-linking`, `complete-linking`). Renders while the page is
 * waiting on a gateway round-trip or a same-tab redirect to a partner's
 * authorize endpoint, so the user sees something other than a blank tab.
 */
export default function LinkingLoading(): JSX.Element {
  const { formatMessage } = useIntl();
  return (
    <Page
      data-testid="partner-linking-loading"
      role="status"
      aria-live="polite"
      aria-label={formatMessage({ id: 'loading' })}
    >
      <Spinner aria-hidden />
    </Page>
  );
}
